import React from "react";
import styled from "styled-components";
import { Form } from "antd";
import { RAButtonPrimary, RATabs, RATextInput, RATypography } from "@/components/customs";

const template = ({ loading, email, setEmail, phone, setPhone, errors, setErrors, type, onChangeTab, onFinish }) => {
	const _renderViaEmailTab = () => {
		return (
			<Form.Item>
				<RATextInput
					title="Email"
					value={email}
					placeholder="Enter your email"
					onChange={(val) => {
						setEmail(val);
						if (errors && errors.email) {
							delete errors.email;
							setErrors(errors);
						}
					}}
					error={errors?.email}
				/>
			</Form.Item>
		);
	};

	const _renderViaPhoneTab = () => {
		return (
			<Form.Item>
				<RATextInput
					title="Phone Number"
					type="phone"
					value={phone}
					placeholder="Enter your phone number"
					onChange={(val) => setPhone(val)}
					error={errors?.phone}
				/>
			</Form.Item>
		);
	};

	const _renderTabs = () => {
		const tabRenderer = [
			{
				key: "email",
				label: "Email",
				render: _renderViaEmailTab(),
			},
			{
				key: "sms",
				label: "Phone Number",
				render: _renderViaPhoneTab(),
			},
		];
		return <RATabs tabRenderer={tabRenderer} currentTab={type} onChange={onChangeTab} />;
	};

	return (
		<Container>
			<Form
				fields={[{ name: "email" }, { name: "password" }]}
				layout="vertical"
				onFinish={onFinish}
				className="form-login-wrapper"
			>
				<FormInputWrapper>
					<WrapperTitle>
						<RATypography variant="h4">Forgot Password</RATypography>
					</WrapperTitle>
					<RATypography variant="body3" bottom="10px" color="#595959">
						Enter your email address or phone number and we’ll send you a link to reset your password
					</RATypography>
					{_renderTabs()}
					<WrapperBottom justify="center">
						<RAButtonPrimary title="SUBMIT" width="180px" onClick={onFinish} loading={loading} />
					</WrapperBottom>
				</FormInputWrapper>
			</Form>
		</Container>
	);
};

const Container = styled.div`
	padding-top: 30px;
	padding-bottom: 30px;
	width: 50vw;
	max-width: 620px;
	min-width: 343px;
	padding: clamp(24px, 8vw, 60px) clamp(16px, 4vw, 60px);

	.ant-input,
	.ant-input-status-success {
		background: transparent;
		outline: 0;
	}
`;
const InputSection = styled.div`
	width: 100%;
`;
const FormInputWrapper = styled.div`
	align-self: center;
`;
const WrapperTitle = styled.div`
	margin-bottom: 20px;
	padding-left: 20px;
	border-left: 2px solid #ffb11a;
`;
const WrapperBottom = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-top: 30px;
	gap: 12px;
`;

export { template };
